module.exports = __webpack_public_path__ + "img/a7.8f79219a.png";